import { SkillData } from "../../models/SkillData";
import SpringSecurity from "../../images/icons/spring-security.png";
import JUnit from "../../images/icons/JUnit.png";
export const webSkills: SkillData[] = [
  {
    name: "Spring",
    img: "https://user-images.githubusercontent.com/25181517/117201470-f6d56780-adec-11eb-8f7c-e70e376cfd07.png",
  },
  {
    name: "Spring Boot",
    img: "https://user-images.githubusercontent.com/25181517/183891303-41f257f8-6b3d-487c-aa56-c497b880d0fb.png",
  },
  {
    name: "Spring Security",
    img: SpringSecurity,
  },
  {
    name: "Hibernate",
    img: "https://user-images.githubusercontent.com/25181517/117207493-49665200-adf4-11eb-808e-a9c0fcc2a0a0.png",
  },
  {
    name: "JUnit",
    img: JUnit,
  },
  {
    name: "Docker",
    img: "https://user-images.githubusercontent.com/25181517/117207330-263ba280-adf4-11eb-9b97-0ac5b40bc3be.png",
  },
  {
    name: "Maven",
    img: "https://user-images.githubusercontent.com/25181517/117207242-07d5a700-adf4-11eb-975e-be04e62b984b.png",
  },
  {
    name: "React",
    img: "https://user-images.githubusercontent.com/25181517/183897015-94a058a6-b86e-4e42-a37f-bf92061753e5.png",
  },
  {
    name: "Node.js",
    img: "https://user-images.githubusercontent.com/25181517/183568594-85e280a7-0d7e-4d1a-9028-c8c2209e073c.png",
  },
  {
    name: "Express",
    img: "https://user-images.githubusercontent.com/25181517/183859966-a3462d8d-1bc7-4880-b353-e2cbed900ed6.png",
  },
  {
    name: "JavaScript",
    img: "https://user-images.githubusercontent.com/25181517/117447155-6a868a00-af3d-11eb-9cfe-245df15c9f3f.png",
  },
  {
    name: "TypeScript",
    img: "https://user-images.githubusercontent.com/25181517/183890598-19a0ac2d-e88a-4005-a8df-1ee36782fde1.png",
  },
  {
    name: "Framer motion",
    img: "https://seeklogo.com/images/F/framer-motion-logo-DA1E33CAA1-seeklogo.com.png",
  },
  {
    name: "Tailwind CSS",
    img: "https://user-images.githubusercontent.com/25181517/202896760-337261ed-ee92-4979-84c4-d4b829c7355d.png",
  },
  {
    name: "MySQL",
    img: "https://user-images.githubusercontent.com/25181517/183896128-ec99105a-ec1a-4d85-b08b-1aa1620b2046.png",
  },
  {
    name: "mongoDB",
    img: "https://user-images.githubusercontent.com/25181517/182884177-d48a8579-2cd0-447a-b9a6-ffc7cb02560e.png",
  },
  {
    name: "REST",
    img: "https://user-images.githubusercontent.com/25181517/192107858-fe19f043-c502-4009-8c47-476fc89718ad.png",
  },
];
